<template>
	<div class="uk-position-relative">
		<form
			method="post"
			id="contact-form"
			accept-charset="UTF-8"
			@submit.prevent="submitForm"
		>
			<fieldset class="uk-fieldset">
				<input type="hidden" :name="csrfName" :value="csrfToken" />
				<input type="hidden" name="message[ip]" :value="userIP" />
				<div class="uk-margins-small">
					<input
						id="from-name"
						type="text"
						class="uk-input"
						name="fromName"
						v-model="formData.name"
						:placeholder="placeholders.name"
						required
					/>
				</div>
				<div class="uk-margin-small">
					<input
						id="from-email"
						type="email"
						class="uk-input"
						name="fromEmail"
						v-model="formData.email"
						:placeholder="placeholders.email"
						required
					/>
				</div>
				<div class="uk-margin-small">
					<input
						id="subject"
						type="text"
						class="uk-input"
						name="subject"
						v-model="formData.subject"
						:placeholder="placeholders.subject"
						required
					/>
				</div>
				<div class="uk-margin-small">
					<textarea
						rows="4"
						cols="30"
						class="uk-textarea"
						id="message"
						name="message[body]"
						v-model="formData.message"
						:placeholder="placeholders.message"
						required
					></textarea>
				</div>
				<input
					type="submit"
					class="uk-button uk-button-primary uk-margin-remove-bottom"
					:value="buttonText"
				/>
			</fieldset>
		</form>
		<div class="overlay" v-show="overlay">
			<div class="uk-position-center">
				<div class="uk-text-center">
					<span v-show="loading"
						><loading-indicator></loading-indicator
					></span>
					<span v-show="error" class="material-symbols-outlined"
						><svg
							xmlns="http://www.w3.org/2000/svg"
							height="24"
							viewBox="0 -960 960 960"
							width="24"
						>
							<path
								d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
							/></svg
					></span>
					<span v-show="success" class="material-symbols-outlined"
						><svg
							xmlns="http://www.w3.org/2000/svg"
							height="24"
							viewBox="0 -960 960 960"
							width="24"
						>
							<path
								d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
							/></svg
					></span>
				</div>
				<p class="uk-text-center">{{ statusMessage }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue'

export default {
	name: 'ContactForm',
	components: {
		LoadingIndicator
	},
	props: {
		csrf: {
			type: Object,
			default () {
				return {
					tokenName: null,
					tokenValue: null
				}
			}
		},
		message: {
			type: String,
			required: false,
		},
		subject: {
			type: String,
			required: false,
		},
		userIP: String,
		placeholders: {
			type: Object,
			required: false,
			default () {
				return {
					name: 'Je naam',
					email: 'Emailadres',
					subject: 'Onderwerp',
					message: 'Bericht'
				}
			}
		},
		buttonText: {
			type: String,
			default: 'Versturen'
		},
		recaptchaSiteKey: {
			type: String
		}
	},
	data() {
		return {
			formData: {
				name: '',
				email: '',
				subject: '',
				message: '',
			},
			overlay: false,
			loading: false,
			error: false,
			errors: {},
			success: false,
			statusMessage: null,
		}
	},
	computed: {
		csrfName() {
			return window.csrfTokenName
		},
		csrfToken() {
			return window.csrfTokenValue
		},
	},
	mounted() {
		console.log('Vue/component/contact-form/mounted');

		var component = this;
		if (component.subject) {
			component.formData.subject = component.subject;
		}
		if (component.message) {
			component.formData.message = component.message;
		}
	},
	created() {
		console.log('Vue/component/contact-form/created');
	},
	methods: {
		formatErrors(errors) {
			let messages = new Set();
			for (let key in errors) {
				if (errors.hasOwnProperty(key)) {
					errors[key].forEach(message => messages.add(message));
				}
			}
			return Array.from(messages).join('<br>');
		},
		resetMessage: function() {
			
			var component = this;
			
			component.statusMessage = null;
			component.error = false;
			component.overlay = false;
			component.loading = false;		
		},
		submitForm(e) {
			console.log('Vue/component/contact-form/submitForm');
		
			e.preventDefault();
		
			var component = this;
		
			// Form data
			var formData = new FormData(e.target);
		
			// Custom data
			var data = {};
		
			// Toggle indicator
			component.overlay = true;
			component.loading = true;
		
			// Add CSFR if not passed to component, should be mounted to window. object
			if (component.csrf.tokenName || !component.csrf.tokenValue) {
				formData.append(
					formData[window.csrfTokenName],
					window.csrfTokenValue
				);
			}
		
			// Function to handle form submission
			const handleFormSubmission = () => {
				axios({
					method: 'post',
					url: '/actions/contact-form/send',
					responseType: 'json',
					data: formData,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
						'Accept': 'application/json'
					}
				})
				.then(function(response) {
		
					component.loading = false;
		
					// Error
					if (response.data.error) {
		
						component.$logger('Vue/component/contact-form/submitForm');
						
						component.error = true;
						component.statusMessage = 'Er ging iets fout, probeer het opnieuw.';
		
						// Success
					} else {
		
						console.log('Vue/contact/success-response');
		
						component.success = true;
						component.statusMessage = 'Bedankt voor je bericht, we proberen z.s.m. te reageren.';
		
						setTimeout(function() {
		
							component.overlay = false;
							component.statusMessage = '';
		
							// clear form
							component.formData = {
								name: '',
								email: '',
								subject: '',
								message: '',
							};
		
						}, 5000);
					}
				})
				.catch(function (error) {
		
					component.$logger('Vue/components/login-register/login/catch', 'error');
					component.$logger(error);
		
					// Json response
					var response = error.response.data;
					var errorCode = response.errorCode;
					var message = response.message;
		
					component.loading = false;
					component.error = true;
					component.statusMessage = (message) ? message : "Onbekende fout, probeer het opnieuw!";
		
					setTimeout(function() {        
						component.resetMessage();
					}, 4000);                
				});
			};
		
			// Check if reCAPTCHA is enabled
			if (component.recaptchaSiteKey) {
				// Get the reCAPTCHA token
				grecaptcha.ready(function() {
					grecaptcha.execute(component.recaptchaSiteKey, { action: 'contact' }).then(function(token) {
						
						// Add the token to the form data
						formData.append('g-recaptcha-response', token);
		
						component.$logger('Vue/component/contact-form/recaptcha-token: ' + token);
						
						// Proceed with form submission
						handleFormSubmission();
					});
				});
			} else {
				// Proceed with form submission without reCAPTCHA
				handleFormSubmission();
			}
		},
	}
} 
</script>

<style scoped>
	.overlay {
		position: absolute;
		top: 0;
		height: 100%;
		width: 100%;
		z-index: 999;
		background-color: rgba(255, 255, 255, 0.9);
	}
</style>
